module.exports = __webpack_public_path__ + "img/slider4.a3da5739.svg";